import React, { useState } from "react";
import { Stack } from "@mui/material";
import moment from "moment/moment";

import { getToken } from "../../../../api/Account";
import { updateAdelantoAsync } from "../../../../api/Employees";
import { useAviso } from "../../../../components/base";
import {
  CampoFecha,
  CampoMonto,
  DialogoFormulario,
  esMontoEscribible,
  useEnvio,
  useEscritura,
} from "../comunes";

const UpdateAdelanto = ({ selected, setShowModal, reload, setReload }) => {
  const [monto, setMonto] = useState(selected.montoAdelanto);
  const [fecha, setFecha] = useState(new Date(selected.fechaCreacion));
  const [intentado, setIntentado] = useState(false);

  const token = getToken();
  const aviso = useAviso();
  const escribir = useEscritura();
  const { guardando, enviar } = useEnvio();

  // Las reglas de siempre: monto vacío y fecha válida.
  const errorMonto = monto.length === 0 ? "Ingrese el monto" : "";
  const errorFecha = !moment(fecha).isValid() ? "Seleccione una fecha válida" : "";

  const saveChanges = () =>
    enviar(async () => {
      setIntentado(true);
      if (errorMonto || errorFecha) return;

      const data = {
        id: selected.id,
        monto,
        fechaCreacion: moment(fecha).format("YYYY-MM-DD"),
      };

      const ok = await escribir(
        () => updateAdelantoAsync(token, data),
        "No se pudo editar el adelanto"
      );
      if (!ok) return;
      aviso.exito("Adelanto editado");
      setReload(!reload);
      setShowModal(false);
    });

  //Devuelve un entero positivo
  const funtionSetMonto = (value) => {
    if (esMontoEscribible(value)) {
      setMonto(value);
    }
  };

  const hayCambios =
    monto !== selected.montoAdelanto ||
    !moment(fecha).isSame(moment(selected.fechaCreacion), "day");

  return (
    <DialogoFormulario
      titulo={`Editar adelanto #${selected.id}`}
      onCerrar={() => setShowModal(false)}
      hayCambios={hayCambios}
      guardando={guardando}
      onEnviar={saveChanges}
      textoEnviar="Guardar cambios"
    >
      <Stack spacing={1} sx={{ pt: 1 }}>
        <CampoFecha
          label="Fecha del adelanto"
          value={fecha}
          onChange={(newValue) => setFecha(newValue)}
          error={intentado ? errorFecha : ""}
          disabled={guardando}
        />
        <CampoMonto
          autoFocus
          required
          label="Monto"
          value={monto}
          onChange={funtionSetMonto}
          error={intentado ? errorMonto : ""}
          disabled={guardando}
        />
      </Stack>
    </DialogoFormulario>
  );
};

export default UpdateAdelanto;
